import * as React from "react";

export const LevelTwo = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={44}
    height={44}
    fill="none"
    {...props}
  >
    <circle cx={22} cy={22} r={22} fill="#169FED" />
    <path
      fill="#fff"
      d="M11.836 19.425c0-1.94.395-3.632 1.184-5.076.79-1.466 1.884-2.594 3.282-3.383 1.399-.812 3-1.218 4.805-1.218 2.324 0 4.241.586 5.753 1.76 1.533 1.15 2.56 2.774 3.079 4.872h-5.11c-.27-.812-.733-1.444-1.387-1.895-.632-.474-1.421-.71-2.369-.71-1.353 0-2.425.495-3.214 1.488-.79.97-1.184 2.357-1.184 4.162 0 1.782.394 3.17 1.184 4.162.79.97 1.86 1.455 3.214 1.455 1.918 0 3.17-.857 3.756-2.572h5.11c-.52 2.03-1.546 3.643-3.08 4.839-1.534 1.195-3.45 1.793-5.752 1.793-1.804 0-3.406-.395-4.805-1.184a8.61 8.61 0 0 1-3.282-3.384c-.79-1.466-1.184-3.17-1.184-5.11Z"
    />
    <path
      fill="#fff"
      d="M16.709 27.154h2.785v5.57h-2.785zM25.854 27.345l2.035-2.282 3.95 7.674-3.293-.013-2.692-5.38Z"
    />
  </svg>
);
